import {  GoDotFill } from "react-icons/go";

const PrimaryFilterButton = ({ label, isSelected, isChildActive, onClick, color, isOpen }) => (
    <button
        className={`filter-btn ${isSelected ? "selected" : "deselected"}`}
        onClick={onClick}
        title={label}
        style={{
            backgroundColor: isSelected ? "var(--colorFront)" : color,
            color: isSelected ? "var(--colorBack)" : "var(--colorFront)",
            borderColor: "var(--colorFront)",
            paddingLeft: isOpen ? "4px" : "4px",
        }}
    >
        <span className="filter-label">{label.toUpperCase()}</span>
        {/*isChildActive && <span className="child-indicator">•</span>*/}
         {true && <GoDotFill size={16}
             className={`child-indicator ${isChildActive ? "active" : ""}`}
         />}
    </button>
);

export default PrimaryFilterButton;
